<!-- 预赛 -->
<template>
    <div class="mod pre-rank-buy">
        <div class="mod__hd">
            <img src="../../../assets/img/base/title-lucky.png" alt="幸运锦理奖" />
        </div>
        <div v-if="nowTime < preRes" class="mod_bd"><txt-wait-res :time="preRes" /></div>
        <div v-else-if="list.length > 0" class="mod_bd">
            <div class="mod__desc">
                <dl>
                    <dd>根据初赛单个擂台得分评定，以此榜为准。</dd>
                </dl>
            </div>
            <div class="k-table k-table--rank skin-match">
                <table cellspacing="0">
                    <tr>
                        <th class="fst">排名</th>
                        <th class="ta_left">账号信息</th>
                        <th class="lst">得分</th>
                    </tr>
                    <template v-for="item in list">
                        <tr v-if="item" :key="item.uid">
                        <td v-if="item.rank > 0">初赛第{{item.rank}}名</td>
                        <td v-else>倒数第{{-item.rank}}名</td>
                        <td class="ta_left"><k-user :nick="item.mobile" :logo="item.logoSrc" /></td>
                        <td class="score">{{item.preScore}}</td>
                        </tr>
                    </template>
                </table>
            </div>
        </div>
        <div v-else class="mod_bd"><txt-loading /></div>
    </div>
</template>

<script>
    import {
        mapGetters
    } from 'vuex'
    export default {
        name: 'pre-rank-lucky',
        computed: {
            ...mapGetters(['nowTime', 'preRes']),
            ...mapGetters('match', {
                getWinner: 'getPreWinner'
            }),
            list() {
                const {
                    getWinner
                } = this
                return [
                    getWinner(66),
                    getWinner(88),
                    getWinner(666),
                    getWinner(888),
                    getWinner(-1)
                ]
            }
        }
    };

</script>
